import { Box } from "@material-ui/core";
import { marginStyles } from "./index.styles";

const Margin = () => {
   const classes = marginStyles();
   return <Box className={classes.margin}></Box>;
};

export default Margin;
